var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"xREG5Ve_r7BaE6D4CsKd1"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["mellin-multi-site@webranking-srl"]={id:"xREG5Ve_r7BaE6D4CsKd1"};
      